import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	asset: null,
	account: null,
	recipient: '',
	amount: '0',
	feeData: { Amount: 0, Fee: 0 },
	comment: 'Transaction',
	withdrawalId: null,
	haveActiveTransactionWarning: false,
	isMaxAmountSetted: false,
	minAmountUsd: 0,
	withdrawalCardId: false,
	approvalFiles: [],
	amlShield: false,
};

export const sendSlice = createSlice({
	name: 'send',
	initialState,
	reducers: {
		resetState: () => initialState,
		setSendData: (state, action) => {
			const { payload: sendData = initialState } = action;
			if (!sendData.asset) {
				return { ...initialState, ...sendData };
			} else if (!sendData.account) {
				return { ...initialState, ...sendData, asset: sendData.asset };
			} else {
				return { ...initialState, ...sendData, asset: sendData.asset, account: sendData.account };
			}
		},
		setRecipient: (state, action) => {
			const { payload: recipient = initialState.recipient } = action;
			state.recipient = recipient;
		},
		setAmount: (state, action) => {
			const { payload: amount = initialState.amount } = action;
			state.amount = amount;
		},
		setFeeData: (state, action) => {
			const { payload: feeData = initialState.feeData } = action;
			state.feeData = feeData;
		},
		setComment: (state, action) => {
			const { payload: comment = initialState.comment } = action;
			state.comment = comment;
		},
		setAsset: (state, action) => {
			const { payload: asset = initialState.asset } = action;
			state.asset = asset;
		},
		setWithdrawalId: (state, action) => {
			const { payload: withdrawalId = initialState.withdrawalId } = action;
			state.withdrawalId = withdrawalId;
		},
		setAccount: (state, action) => {
			const { payload: account = initialState.account } = action;
			state.account = account;
		},
		setHaveActiveTransactionWarning: (state, action) => {
			const { payload: haveActiveTransactionWarning = initialState.haveActiveTransactionWarning } = action;
			state.haveActiveTransactionWarning = haveActiveTransactionWarning;
		},
		setIsMaxAmountSetted: (state, action) => {
			const { payload: isMaxAmountSetted = initialState.isMaxAmountSetted } = action;
			state.isMaxAmountSetted = isMaxAmountSetted;
		},
		setMinAmountUsd: (state, action) => {
			const { payload: minAmountUsd = initialState.minAmountUsd } = action;
			state.minAmountUsd = minAmountUsd;
		},
		setWithdrawalCardId: (state, action) => {
			const { payload: withdrawalCardId = initialState.withdrawalCardId } = action;
			state.withdrawalCardId = withdrawalCardId;
		},
		setApprovalFiles: (state, action) => {
			state.approvalFiles = action.payload;
		},
		addApprovalFile: (state, action) => {
			state.approvalFiles.push(action.payload);
		},
		setAmlShield: (state, action) => {
			const { payload: amlShield = initialState.amlShield } = action;
			state.amlShield = amlShield;
		},
	},
});
